import axios from 'axios'
import authHeader from '../../services/AuthHeader'

const MS_MAXIMO = process.env.VUE_APP_MS_MAXIMO

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'; // Remplacez '*' par le domaine approprié si nécessaire
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS'; // Remplacez par les méthodes HTTP que vous utilisez
axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Authorization, Content-Type, X-Requested-With'; // Remplacez par les en-têtes nécessaires



const state = () => ({
    agreements:[],
    assets:[],
    wos:[],
    srs:[],
    histories:[]
})

const getters = {

    getAgreements(state){
        if(state.agreements.length>0){
            return state.agreements
        }
        let agreements  = localStorage.getItem("agreements")
        if(agreements != null){
            state.agreements = JSON.parse(agreements)
        }
        return state.agreements
    },

    getAssets(state){
        if(state.assets.length > 0){
            return state.assets
        }
        let assets = localStorage.getItem("assets")
        if(assets != null){
            state.assets = JSON.parse(assets)
        }
        return state.assets
    },

    getWos(state){
        return state.wos
    },

    getSrs(state){
        return state.srs
    },

    getHistories(state){
        return state.histories
    }
}

const mutations = {

    saveAgreements(state, data){
        localStorage.setItem("agreements", JSON.stringify(data))
        state.agreements = data
    },

    saveAssets(state, data){
        state.assets = data
        localStorage.setItem("assets", JSON.stringify(data))
    },

    saveWos(state, data){
        state.wos = data
    },

    saveSrs(state, data){
        state.srs = data
    },

    saveHistories(state, data){
        state.histories = data
    }

}

const actions = {

    async loadAgreements({commit}, value){
        const response = await axios.get(`${MS_MAXIMO}/secure/agreement/` + value)
        .catch(err => {
            console.log("store agreements:" + err)
        })
        if(response && response.data){
            commit("saveAgreements", response.data)
        }else{
            commit("saveAgreements",[])
        }
    },

    async loadAssets({commit}, payload){
        let path = MS_MAXIMO + "/secure/assets/customer/" 
        + payload.customer + "/" + payload.start + "/" + payload.end
        const response = 
        await axios.get(`${path}` , 
            {headers: authHeader()})
        .catch(err => {
            console.log("store assets:" + err)
        })
        if(response && response.data){
            commit("saveAssets", response.data)
        }else{
            commit("saveAssets",[])
        }
    },

    async loadWos({commit}, payload){
        const response = 
        await axios.get(`${MS_MAXIMO}/secure/cworkorders/customer?customer=${payload.customer}&start=${payload.start}&end=${payload.end}`, {headers: authHeader()})
        .catch(err => {
            console.log("store wos:" + err)
        })
        if(response && response.data){
            commit("saveWos", response.data)
        }else{
            commit("saveWos",[])
        }
    },

    async loadSrs({commit}, payload){
        let path = "";
        if(payload.scope == "external"){
            path = MS_MAXIMO + "/secure/sr/only/customer?customer="
            +payload.customer+"&start="+payload.start+"&end="+payload.end
        }else{
            path = MS_MAXIMO + "/secure/sr/customer?customer="
            +payload.customer+"&start="+payload.start+"&end="+payload.end
        }
        const response = 
        await axios.get(`${path}`, {headers: authHeader()})
        .catch(err => {
            console.log("store srs:" + err)
        })
        if(response && response.data){
            commit("saveSrs", response.data)
        }else{
            commit("saveSrs",[])
        }
    },

    async loadHistories({commit}, customer){
        const response = 
        await axios.get(`${MS_MAXIMO}/secure/workorders/history?customer=${customer}`, {headers: authHeader()})
        .catch(err => {
            console.log("store histories:" + err)
        })
        if(response && response.data){
            commit("saveHistories", response.data)
        }else{
            commit("saveHistories",[])
        }
    },

}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}